var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "share-container",
        on: {
          touchstart: _vm.dragstart,
          touchend: _vm.dragend,
          touchmove: _vm.dragmove
        }
      },
      [
        _c("transition", { attrs: { name: "fade", mode: "in-out" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.shareLoading,
                  expression: "shareLoading"
                }
              ],
              staticClass: "share-loading"
            },
            [
              _c("div", { staticClass: "loading-indicator" }, [
                _c("div"),
                _vm._v(" "),
                _c("div"),
                _vm._v(" "),
                _c("div")
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("We're putting your outfit together. You'll love it.")
              ]),
              _vm._v(" "),
              _c("img", { attrs: { src: _vm.shareImageUrl } }),
              _vm._v(" "),
              _vm.currentIcon
                ? _c(_vm.currentIcon, { tag: "component" })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade", mode: "in-out" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.shareLoading,
                  expression: "!shareLoading"
                }
              ]
            },
            [
              _c(
                "div",
                { staticClass: "image-container" },
                [
                  _vm.imageLoading ? _c("loader") : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "image-wrapper",
                      style: _vm.imageWrapperStyle
                    },
                    [
                      _c("img", {
                        attrs: { src: _vm.shareImageUrl },
                        on: { load: _vm.onImageLoad }
                      })
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "buttom-menu", style: _vm.menuStyle }, [
                _c("div", { staticClass: "handle" }),
                _vm._v(" "),
                _c("div", { staticClass: "container" }, [
                  _vm.title
                    ? _c("p", { staticClass: "heading" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "link-container" }, [
                    _vm.instagramInstalled
                      ? _c(
                          "p",
                          { class: _vm.shareButtonClass },
                          [
                            _c("instagram-icon"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "link",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    $event.preventDefault()
                                    return _vm.shareInstagram.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Share on Instagram")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "p",
                      { class: _vm.shareButtonClass },
                      [
                        _c("facebook-icon"),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.shareFacebook.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Share on Facebook")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "p",
                      { class: _vm.shareButtonClass },
                      [
                        _c("sms-icon"),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "link",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.shareSMS.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Share via SMS")]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1df72ebd", { render: render, staticRenderFns: staticRenderFns })
  }
}